import React from 'react';
import './LegalPages.css';

const RefundPolicyPage = () => {
  return (
    <div className="legal-page-wrapper">
      <header className="legal-header">
        <h1>Refund Policy</h1>
        <p>Effective as of August 6, 2025</p>
      </header>

      <main className="legal-page">
        <p>
          At <strong>Redfox Digital</strong>, we are committed to delivering high-quality digital services tailored to each client’s specific needs. Our team invests significant time, effort, and expertise into every project.
        </p>

        <h3>Strict No-Refund Policy</h3>
        <p>
          Due to the nature of our work — which involves custom design, development, marketing, and consulting services — <span style={{color: "#dc2626", textTransform:"uppercase"}}><strong>we do not offer any refunds once payment is made and the project has commenced.</strong></span>
        </p>

        <h3>Why We Don’t Offer Refunds</h3>
        <ul>
          <li>Our services are labor-intensive and begin immediately after payment.</li>
          <li>Each project is tailored to the client and cannot be resold or reused.</li>
          <li>We dedicate team resources and block schedules upon engagement.</li>
        </ul>

        <h3>Before You Proceed</h3>
        <p>
          We strongly recommend reviewing our portfolio, discussing your expectations clearly, and asking any questions prior to payment. Our team is available to provide clarity on deliverables, timelines, and outcomes.
        </p>

        <h3>Need Help?</h3>
        <p>
          If you have any concerns or need support, please <a href="/contact">contact us</a>. We are always happy to work with you to resolve any issues or improve your experience.
        </p>
      </main>
    </div>
  );
};

export default RefundPolicyPage;
